import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'

import WhatshotIcon from '@mui/icons-material/Whatshot'

import { containerSx, matchesIconSx, matchesLinesSx } from './styles'

interface IMatchesCountIcon {
  color: 'light' | 'dark'
  size: 'small' | 'large'
}

const MatchesCountIcon = ({ color, size }: IMatchesCountIcon) => {
  const { t } = useTranslation()

  return (
    <Box aria-label={t('Matches count icon')} sx={containerSx(size)}>
      <Box
        alt={t('Animated Match Icon')}
        loading="lazy"
        component="img"
        src="/images/matches-lines.png"
        sx={matchesLinesSx(size)}
      />

      <WhatshotIcon sx={matchesIconSx({ color, size })} />
    </Box>
  )
}

export { MatchesCountIcon }
